import React, { useState } from "react";
import {
  FiPlus,
  FiCalendar,
  FiPhone,
  FiDownload,
  FiX,
} from "react-icons/fi";
import "./FloatingActions.css";

export default function FloatingActions() {
  const [open, setOpen] = useState(false);

  const toggleMenu = () => {
    setOpen((prev) => !prev);
  };

  return (
    <div className={`FloatingActions ${open ? "open" : ""}`}>
      <div className="FloatingActions_menu">
        <a
          href="/contact" target="__blank"
          className="FloatingActions_item item-1"
          aria-label="Prendre rendez-vous"
          title="Prendre rendez-vous"
        >
          <FiCalendar />
          <span>Rendez-vous</span>
        </a>

        <a
          href="tel:21624870001"
          className="FloatingActions_item item-2"
          aria-label="Appeler directement"
          title="Appeler directement"
        >
          <FiPhone />
          <span>Appeler</span>
        </a>

        <a
          href="https://firebasestorage.googleapis.com/v0/b/elements-590a4.firebasestorage.app/o/Catalogue%20Elements_260408_164638%20(1).pdf?alt=media&token=f202712a-acba-49c9-9bc6-27aa226fae81"
          download
          className="FloatingActions_item item-3"
          aria-label="Télécharger le catalogue"
          title="Télécharger le catalogue"
        >
          <FiDownload />
          <span>Catalogue</span>
        </a>
      </div>

      <button
        className="FloatingActions_toggle"
        onClick={toggleMenu}
        aria-label={open ? "Fermer le menu rapide" : "Ouvrir le menu rapide"}
      >
        <span className="FloatingActions_toggleIcon">
          {open ? <FiX /> : <FiPlus />}
        </span>
      </button>
    </div>
  );
}